var extractLozengeActionItems = function extractLozengeActionItems(response) {
  var _response$transitions, _response$transitions2;
  var items = (_response$transitions = response === null || response === void 0 || (_response$transitions2 = response.transitions) === null || _response$transitions2 === void 0 ? void 0 : _response$transitions2.map(function (_ref) {
    var _ref2;
    var appearance = _ref.appearance,
      id = _ref.id,
      name = _ref.name;
    return {
      appearance: (_ref2 = appearance) !== null && _ref2 !== void 0 ? _ref2 : 'default',
      id: id,
      text: name
    };
  })) !== null && _response$transitions !== void 0 ? _response$transitions : [];
  return items.sort(function (a, b) {
    return a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text);
  });
};
export default extractLozengeActionItems;